import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { TopNav } from "../Nav/TopNav";
import { SideNav } from "../Nav/SideNav";

const TOP_NAV_HEIGHT = 64;

const LayoutRoot = styled("div")<{ sideNavWidth: number }>(
  ({ theme, sideNavWidth }) => ({
    display: "flex",
    flex: "1 1 auto",
    maxWidth: "100%",
    [theme.breakpoints.up("lg")]: {
      paddingLeft: sideNavWidth,
    },
  })
);

const LayoutContainer = styled("div")({
  display: "flex",
  flex: "1 1 auto",
  flexDirection: "column",
  width: "100%",
});

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = (props) => {
  const { children } = props;
  const location = useLocation();
  const pathname = location.pathname;
  const [openNav, setOpenNav] = useState(false);

  const handlePathnameChange = useCallback(() => {
    if (openNav) {
      setOpenNav(false);
    }
  }, [openNav]);

  useEffect(
    () => {
      handlePathnameChange();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pathname]
  );

  const [sideNavWidth, setSideNavWidth] = useState<number>(64);

  const toggleSideNav = () => {
    // Toggle the sideNavWidth value between 64 and 280
    setSideNavWidth((prevWidth) => (prevWidth === 64 ? 280 : 64));
  };

  return (
    <>
      <TopNav
        onNavOpen={() => setOpenNav(true)}
        sideNavWidth={sideNavWidth}
        topNavHeight={TOP_NAV_HEIGHT}
      />
      <SideNav
        onClose={() => setOpenNav(false)}
        open={openNav}
        sideNavWidth={sideNavWidth}
        topNavHeight={TOP_NAV_HEIGHT}
        toggleSideNav={toggleSideNav}
      />
      <LayoutRoot sideNavWidth={sideNavWidth}>
        <LayoutContainer>{children}</LayoutContainer>
      </LayoutRoot>
    </>
  );
};
